import { Avatar, Typography } from "@mui/material";

interface Props {
  text: string;
  backgroundColor: string;
  textColor: string;
}

const ListNumbering = ({ backgroundColor, text, textColor }: Props) => {
  return (
    <Avatar
      sx={{
        bgcolor: backgroundColor,
        width: { md: "48px", sm: "48px", xs: "42px" },
        height: { md: "48px", sm: "48px", xs: "42px" },
      }}
    >
      {" "}
      <Typography color={textColor}>{text}</Typography>
    </Avatar>
  );
};

export default ListNumbering;
